import {post} from "../../../utils/request";
import {USER_INFO} from '../../../utils/api';
import * as constants from './constants';

export const UserInfo = (Entity) => ({
    type: constants.USER_INFO,
    value: Entity
});


export const getUserInfo = () => {
    return (dispatch) => {
        return post(USER_INFO, {})
            .then((response) => {
                return dispatch(UserInfo(response.data));
            });
    }
};
